import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { fetchGitOrgs } from '@/services/git/api';
import type { GitOrg } from '@/services/git/types';
import { useAuthStoreV1 } from '@/stores/authStore_v1';

export function useGitOrgs(): UseQueryResult<GitOrg[], Error> {
  const token = useAuthStoreV1((s) => s.token);
  const orgId = useAuthStoreV1((s) => s.selectedOrg?.id);

  return useQuery({
    queryKey: ['gitOrgs', orgId],
    queryFn: () => fetchGitOrgs(orgId!),
    enabled: !!token && !!orgId,
    staleTime: 5 * 60 * 1000,
    retry: false,
    refetchOnWindowFocus: false,
  });
}
